import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "day", "month", "year" ]

  connect() {
    this.updateDays()
  }

  updateDays() {
    const month = parseInt(this.monthTarget.value)
    const yearInput = parseInt(this.yearTarget.value)

    if (!month) {
      this.toggleDayOptions(31)
      return
    }

    const year = yearInput || 2000

    const daysInMonth = new Date(year, month, 0).getDate()

    this.toggleDayOptions(daysInMonth)
  }

  toggleDayOptions(maxDays) {
    const daySelect = this.dayTarget
    const options = daySelect.querySelectorAll("option")

    options.forEach(option => {
      const dayValue = parseInt(option.value)

      if (!dayValue) return

      if (dayValue > maxDays) {
        option.hidden = true
        option.disabled = true

        if (daySelect.value == option.value) {
          daySelect.value = ""
        }
      } else {
        option.hidden = false
        option.disabled = false
      }
    })
  }
}
